<mat-button-toggle-group [formControl]="formControl" name="fontStyle" aria-label="Font Style">
  <mat-button-toggle *ngFor="let option of options" [value]="option.value">{{option.label}}</mat-button-toggle>
</mat-button-toggle-group>
